const _UNLOCKCHECK = 5000;

Vue.component('openPack', {
  template: templates.openPack,
  data() {
    return {
      model: {
        id: null,
        twitchId: null,
        twitchDisplayName: null,
        settings: {},
        card: [{
          id: '1'
        }],
        userCards: null,
        packLoaded: false,
        scrollInterval: null,
        abilities: null,
        audio: {},
        index: 0,
        pack: 'standard',
        cards: {},
        packs: {}
      }
    }
  },
  mounted() {
    const c = this;
    
    c.setupSound(); 
    c.getPacks();
    c.getSettings();
    c.getCards();
    c.getAbilities();
  },
  methods: {
    getSettings() {
      const c = this;
      
      let data = {};

      settingsService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.key}`] = d;
          }
          c.model.settings = data;

          setTimeout(function() {
            c.getSettings();
          }, 30000);
        })
        .catch(function (error) {
          
        });

    },
    getCards() {
      const c = this;

      cardService.get()
        .then(function (response) {
          c.model.cards = response.data;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    setupSound() {
      const c = this;

      c.model.audio.award = new Audio('../audio/whoosh-03.mp3');

      // c.model.audio.award.addEventListener('ended', () => {
      //   c.model.audio.award.playing = 'false';
        
      // }, false);

      //Setup card flip sound and ended callback
      c.model.audio.flip = new Audio('../audio/card-flip.mp3');
      //Audio ended triggers next card flip
      c.model.audio.flip.addEventListener('ended', () => {
        c.model.audio.flip.playing = 'false';
        c.flipCards();
      }, false);
      
    },
    getPacks() {
      const c = this;
      let data = {};

      packService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.packs = data;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    getAbilities() {
      const c = this;

      let data = {};

      abilityService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.abilities = data;
          c.getUnlocks();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    getUnlocks() {
      const c = this;

      //Prevent calling api while a pack is loaded
      if (c.model.packLoaded) {
        return;
      }

      if (c.model.settings.autoopen && c.model.settings.autoopen.value) {

        //Spreads out the open packs to every 6 seconds
        setTimeout(function() {

          unlockQueueService.getAuto()
            .then(function (response) {
              c.processPackOpen(response.data[0]);
            })
            .catch(function (error) {
              setTimeout(function() {
                c.getUnlocks();
              }, _UNLOCKCHECK);
            });

        }, 3000);

      } else {

        unlockQueueService.getActive()
          .then(function (response) {
            c.processPackOpen(response.data[0]);
          })
          .catch(function (error) {
            setTimeout(function() {
              c.getUnlocks();
            }, _UNLOCKCHECK);
          });

      }
    },
    processPackOpen(data) {
      const c = this;

      let id = data.id;

      c.model.packLoaded = true;
      if (id != c.model.id) {

        c.model.id = id;
        c.model.twitchId = data.twitchId;
        c.model.twitchDisplayName = data.twitchDisplayName;
        c.model.pack = c.model.packs[data.packId];

        c.saveCards(data, function() {

          c.getUserCards(function() {
            setTimeout(function() {

              if (c.model.twitchDisplayName == null) {
                c.getTwitchName();
              } else {
                c.open();
                c.save();
              }

            }, 1500);
          })
          
        })
      } else {
        setTimeout(function() {
          c.getUnlocks();
        }, _UNLOCKCHECK);
      }
    },
    saveCards(data, callback) {
      const c = this;

      let pack = c.model.packs[data.packId];
      let packSize = Number(pack.size);
      let saved = 0;
      let cards = playingCards.openPack(pack, c.model.cards);
      
      for (let i = 0; i < cards.length; i++) {

        userService.saveCards({twitchId: data.twitchId, unlockQueueId: data.id, cardId: cards[i].id, tier: cards[i].tier})
          .then(function (response) {
            saved += 1;
            if (saved == packSize) {
              callback();
            }
          })
          .catch(function (error) {
            //console.log(error);
          });

      }
    },
    getUserCards(callback) {
      const c = this;
      let cards = [];
      
      userService.getCards({twitchId: c.model.twitchId, id: c.model.id})
        .then(function (response) {
          
          for (let card of response.data) {
            cards.push(card);
          }
          
          c.model.userCards = playingCards.getCardsStats(cards, c.model.abilities);
          
          callback();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    getTwitchName() {
      const c = this;
      let url = `${apiUrl}users?id=${c.model.twitchId}`;
      
      //TODO refactor into univarsal function
      axios.get(url, {
          headers: { 
            'Client-ID': clientId,
            'Authorization': `Bearer ${utils.cookies.get('access_token')}` 
          }
        })
        .then(function (response) {
          for (let d of response.data.data) {
            c.model.twitchDisplayName = d.display_name ? d.display_name : null;
          }
          c.open();
          c.save();
        })
        .catch(function (error) {
          //Just in case it couldn't load the user name from the API
          c.open();
          c.save();
        });
    },
    scroll() {
      const c = this;

      const cardsContainer = document.getElementById('opened-cards');
      cardsContainer.scrollLeft = 0;

      clearInterval(c.model.scrollInterval);
      c.model.scrollInterval = null; 

      let checkDone = 0;
      let lastScrollLeft = 0;
      cardsContainer.scrollLeft = 0;
      
      let mouseDown = false;

      document.body.onmousedown = function() { 
        mouseDown = true;
      }

      document.body.onmouseup = function() {
        mouseDown = false;
      }

      if (!c.model.scrollInterval) {
        cardsContainer.scrollLeft = 0;
      }

      c.model.scrollInterval = setInterval(() => {
        lastScrollLeft = cardsContainer.scrollLeft;
        
        if (checkDone < 333 && !mouseDown) {
          cardsContainer.scrollTo(cardsContainer.scrollLeft + 1, 0);
        } else if (checkDone >= 333) {
        
          clearInterval(c.model.scrollInterval);
          c.model.scrollInterval = null; 
          setTimeout(function() {
            //cardsContainer.scrollLeft = 0;
            c.reset();
            //c.getUnlocks();
          }, 8000);
        }

        if (cardsContainer.scrollLeft == lastScrollLeft) {
          checkDone += 1;
        }
      }, 15);

    },
    reset() {
      window.location.reload();
    },
    save() {
      const c = this;

      unlockQueueService.save({id: c.model.id, open: true})
      .then(function (response) {
        
      })
      .catch(function (error) {
        //console.log(error);
      });
    },
    open() {
      const c = this;

      let $card = $('.cover');

      $card.removeClass('pulse');

      $card.addClass('expand');
      //utils.explosion();
      
      c.model.audio.award.play();

      setTimeout(function() {
        $card.addClass('fade-out');
      }, 1000);

      setTimeout(function() {
        $card.addClass('hide');
      }, 1500);

      setTimeout(function() {
        //utils.explosion();
      }, 1300);

      setTimeout(function() {
        $('.opened-cards').toggleClass('opened').addClass(`cards-${c.model.userCards.length}`);

        setTimeout(function() {
          $('.open-pack-container').removeClass('collapsed').addClass('show');
          $('.open-pack-container h2').addClass('show');

          setTimeout(function() {
            setTimeout(function() {
              //c.explosions();
              c.flipCards();
              setTimeout(function() {
                c.scroll();
              }, 1000); 
            }, 500);
          }, 1000);
        }, 500); 
      }, 1300);
    },
    explosions() {
      utils.explosion();

      setTimeout(function() {
        utils.explosion();
      }, 1400);

      setTimeout(function() {
        utils.explosion();
      }, 2800);
    },
    flipCards() {
      let c = this;
      let count = $('.opened-cards .playing-card').length;

      if (c.model.index == count) {
        c.model.index = 0;
        return;
      }

      c.model.index += 1;

      //let $card = $('.opened-cards .playing-card')[c.model.index];
      $('.info').removeClass('is-visible');
      $('.bottom').removeClass('is-hidden');
      $(`.playing-card-container:nth-of-type(${c.model.index}) .playing-card`).trigger('click');
      //$card.trigger('click');

      c.model.audio.flip.load();
      c.model.audio.flip.play();

      //$('.opened-cards .playing-card').each(function(index) {
        // $('.info').removeClass('is-visible');
        // $('.bottom').removeClass('is-hidden');
        // $card.trigger('click');
        
      //});

    }
  }
});